"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _classnames = _interopRequireDefault(require("classnames"));

var s = _interopRequireWildcard(require("./Pagination.style"));

var _consts = require("./consts");

var _Buttons = require("./Buttons");

var _Page = _interopRequireDefault(require("./Page"));

var _Separator = require("./Separator");

var _class, _temp;

var Pagination = (0, _emotionTheming.withTheme)(_class = (_temp =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Pagination, _PureComponent);

  function Pagination(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Pagination);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Pagination).call(this, props));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handlePrevious", function () {
      return _this.handlePageClick(_this.state.current - 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handleNext", function () {
      return _this.handlePageClick(_this.state.current + 1);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "handlePageClick", function (page) {
      var _this$props = _this.props,
          current = _this$props.current,
          total = _this$props.total,
          pageSize = _this$props.pageSize;
      var firstPage = 0;
      var lastPage = Math.floor((total - 1) / pageSize);
      if (page < firstPage || page > lastPage) return;

      if (!Number.isInteger(current)) {
        _this.setState({
          current: page
        });
      }

      _this.props.onChange(page);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)), "renderPage", function (pageNumber) {
      return _react.default.createElement(_Page.default, {
        label: pageNumber,
        key: pageNumber,
        current: _this.state.current,
        theme: _this.props.theme,
        onClick: _this.handlePageClick,
        isDarkTheme: _this.props.themeType === 'dark'
      });
    });
    _this.state = {};

    if (Number.isInteger(props.defaultCurrent)) {
      _this.state.current = props.defaultCurrent;
    } else {
      _this.state.current = props.current || 0;
    }

    return _this;
  }

  (0, _createClass2.default)(Pagination, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (Number.isInteger(nextProps.current)) {
        this.state.current = nextProps.current;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          total = _this$props2.total,
          pageSize = _this$props2.pageSize,
          theme = _this$props2.theme,
          themeType = _this$props2.themeType;
      var current = this.state.current;
      var firstPage = 0;
      var lastPage = Math.floor((total - 1) / pageSize);
      var isDarkTheme = themeType === 'dark';

      if (total === 0) {
        return _react.default.createElement("div", {
          className: (0, _classnames.default)(className, s.root)
        });
      }

      if (current > lastPage) {
        current = lastPage;
        this.handlePageClick(current);
      }

      var pages = [current];
      var pagesOnEachSide = Math.floor(_consts.PAGER_SIZE / 2);

      for (var i = current - 1; i >= current - pagesOnEachSide; i -= 1) {
        if (i < firstPage || i > lastPage) break;
        pages.unshift(i);
      }

      for (var _i = current + 1; pages.length < _consts.PAGER_SIZE; _i += 1) {
        if (_i < firstPage || _i > lastPage) break;
        pages.push(_i);
      }

      for (var _i2 = pages[0] - 1; pages.length < _consts.PAGER_SIZE; _i2 -= 1) {
        if (_i2 < firstPage || _i2 > lastPage) break;
        pages.unshift(_i2);
      }

      var leftMost = pages[0];
      var rightMost = pages[pages.length - 1];
      return _react.default.createElement("div", {
        className: (0, _classnames.default)(className, s.root)
      }, _react.default.createElement(_Buttons.PreviousButton, {
        current: current,
        firstPage: firstPage,
        onClick: this.handlePrevious,
        isDarkTheme: isDarkTheme
      }), firstPage < leftMost && this.renderPage(firstPage), _react.default.createElement(_Separator.LeftSeparator, {
        firstPage: firstPage,
        leftMost: leftMost,
        theme: theme,
        isDarkTheme: isDarkTheme
      }), pages.map(this.renderPage), _react.default.createElement(_Separator.RightSeparator, {
        lastPage: lastPage,
        rightMost: rightMost,
        theme: theme,
        isDarkTheme: isDarkTheme
      }), lastPage > rightMost && this.renderPage(lastPage), _react.default.createElement(_Buttons.NextButton, {
        current: current,
        lastPage: lastPage,
        onClick: this.handleNext,
        isDarkTheme: isDarkTheme
      }));
    }
  }]);
  return Pagination;
}(_react.PureComponent), _temp)) || _class;

Pagination.propTypes = {
  className: _propTypes.default.string,
  current: _propTypes.default.number,
  defaultCurrent: _propTypes.default.number,
  pageSize: _propTypes.default.number.isRequired,
  total: _propTypes.default.number.isRequired,
  onChange: _propTypes.default.func,
  themeType: _propTypes.default.string
};
Pagination.defaultProps = {
  className: '',
  defaultCurrent: undefined,
  current: undefined,
  onChange: function onChange() {},
  themeType: 'light'
};
var _default = Pagination;
exports.default = _default;